import Seo from "@/components/feature/Seo";
import Container from "@/components/base/Container";
import PageHero from "@/components/base/PageHero";
import ServiceCard from "@/components/feature/ServiceCard";
import ProcessSection from "@/pages/home/components/ProcessSection";
import CtaSection from "@/pages/home/components/CtaSection";
import { useServicios } from "@/hooks/usePublicContent";

export default function Servicios() {
  const serviceList = useServicios();

  return (
    <>
      <Seo
        title="Servicios de transporte y logística"
        description="Mudanzas, acarreo, eventos, distribución y transporte empresarial. Conoce todos los servicios de transporte y logística de AXONIA GROUP."
        path="/servicios"
      />
      <PageHero
        title="Servicios de transporte y logística"
        subtitle="Soluciones para mudanzas, acarreo, eventos, distribución, transporte empresarial, grupos y requerimientos especiales."
        crumbs={[{ label: "Inicio", to: "/" }, { label: "Servicios" }]}
        image="https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20a%20fleet%20of%20white%20logistics%20vehicles%20on%20a%20clean%20open%20terminal%20at%20blue%20hour%2C%20professional%20corporate%20transport%20photography%2C%20deep%20blue%20tones%2C%20high%20detail&width=1920&height=700&seq=axonia-hero-servicios&orientation=landscape"
      />

      <section className="bg-background-50 py-14 md:py-20">
        <Container>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {serviceList.map((service, index) => (
              <ServiceCard key={service.id} service={service} index={index} />
            ))}
          </div>
        </Container>
      </section>

      <ProcessSection />
      <CtaSection />
    </>
  );
}